/**
 * Módulo para controlar los checks legales de terceros
 * 
 * Funcionalidades:
 * - Check principal que marca/desmarca todos los secundarios
 * - Checks secundarios que marcan el principal cuando se seleccionan
 * - Icono que muestra/oculta el panel de checks secundarios
 */

(function() {
    'use strict';

    // IDs de los elementos
    const MAIN_CHECKBOX_ID = 'check_legal_terceros';
    const ICON_ID = 'gesfor-check-terceros-legales-icon';
    const PANEL_ID = 'gesfor-check-terceros-legales';
    
    // IDs de los checkboxes secundarios
    const SECONDARY_CHECKBOXES = [
        'check_inmobiliarias',
        'check_cambio_suministros', 
        'check_mudanzas',
        'check_hipotecas',
        'check_fiscalidad',
        'check_inversion',
        'check_rehabilitacion',
        'check_alquiler',
        'check_seguridad'
    ];

    // Elementos del DOM
    let mainCheckbox = null;
    let secondaryCheckboxes = [];
    let icon = null;
    let panel = null;

    /**
     * Inicializa el módulo
     */
    function init() {
        // Buscar elementos en el DOM
        mainCheckbox = document.getElementById(MAIN_CHECKBOX_ID);
        icon = document.getElementById(ICON_ID);
        panel = document.getElementById(PANEL_ID);

        // Buscar checkboxes secundarios
        SECONDARY_CHECKBOXES.forEach(id => {
            const checkbox = document.getElementById(id);
            if (checkbox) {
                secondaryCheckboxes.push(checkbox);
            }
        });

        // Verificar que existen los elementos necesarios
        if (!mainCheckbox || !icon || !panel) {
            console.warn('Legales Terceros: No se encontraron todos los elementos necesarios');
            return;
        }

        // Configurar event listeners
        setupEventListeners();
        
        console.log('Legales Terceros: Módulo inicializado correctamente');
    }

    /**
     * Configura los event listeners
     */
    function setupEventListeners() {
        // Event listener para el checkbox principal
        mainCheckbox.addEventListener('change', handleMainCheckboxChange);

        // Event listeners para los checkboxes secundarios
        secondaryCheckboxes.forEach(checkbox => {
            checkbox.addEventListener('change', handleSecondaryCheckboxChange);
        });

        // Event listener para el icono (mostrar/ocultar panel)
        icon.addEventListener('click', togglePanel);
    }

    /**
     * Maneja el cambio en el checkbox principal
     */
    function handleMainCheckboxChange() {
        const isChecked = mainCheckbox.checked;
        
        // Marcar/desmarcar todos los checkboxes secundarios
        secondaryCheckboxes.forEach(checkbox => {
            checkbox.checked = isChecked;
        });
    }

    /**
     * Maneja el cambio en los checkboxes secundarios
     */
    function handleSecondaryCheckboxChange() {
        // Verificar si algún checkbox secundario está marcado
        const hasAnyChecked = secondaryCheckboxes.some(checkbox => checkbox.checked);
        
        // Si alguno está marcado, marcar el principal
        if (hasAnyChecked && !mainCheckbox.checked) {
            mainCheckbox.checked = true;
        }
        
        // Nota: No desmarcamos el principal aunque se desmarquen todos los secundarios
        // según los requisitos especificados
    }

    /**
     * Alterna la visibilidad del panel de checkboxes secundarios
     */
    function togglePanel() {
        if (panel.classList.contains('gesfor-hidden')) {
            showPanel();
        } else {
            hidePanel();
        }
    }

    /**
     * Muestra el panel de checkboxes secundarios
     */
    function showPanel() {
        panel.classList.remove('gesfor-hidden');
        icon.setAttribute('aria-expanded', 'true');
    }

    /**
     * Oculta el panel de checkboxes secundarios
     */
    function hidePanel() {
        panel.classList.add('gesfor-hidden');
        icon.setAttribute('aria-expanded', 'false');
    }

    /**
     * API pública del módulo
     */
    window.GesforLegalesTerceros = {
        init: init,
        showPanel: showPanel,
        hidePanel: hidePanel,
        togglePanel: togglePanel
    };

    // Auto-inicialización cuando el DOM esté listo
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', init);
    } else {
        init();
    }

})();